import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Box,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Checkbox,
  Menu,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  TableContainer,
  Grid,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import apiConfigs from "../../config/config";
import { useDispatch, useSelector } from "react-redux";
import { getInvoice } from "../../store/action/invoice/invoiceAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import Notification from "../../components/Notification/Notification";
import axios from "axios";
import FilterListIcon from "@material-ui/icons/FilterList";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getBookingTrust } from "../../store/action/booking/bookingAction";
import moment from "moment";
import { customEnLocale } from "../../helper/customLocale";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import GetAppIcon from '@material-ui/icons/GetApp';
import Loading from "../../components/Loading/Loading";
import TablePaginationControls from "../../components/TablePaginationControls";
import { Link as RouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import { ThemeContext } from "../../App";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: 'auto',
    padding: 20,
    background: theme.palette.background.main

  },

  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
    overflow: "auto",
  },

  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      padding: "8px !important",
    },
  },
  filterBox: {
    padding: 8,
  },
  radioGroup: {
    flexDirection: "row",
  },
}));

const Invoice = ({ match }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = useState(15);
  const { getInvoiceItem, loading } = useSelector((state) => state.invoice);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("invoice_number");
  const [timesheetMsgError, setTimesheetError] = useState("");
  const [loadings, setLoadings] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [trust, setTrust] = useState([]);
  const loginUserInfo = JSON.parse(
    window.localStorage.getItem("loginUserInfo")
  );
  let firstDayOfWeek = getMonday(new Date());
  firstDayOfWeek = moment(firstDayOfWeek).format("MM-DD-yyyy");
  const history = useHistory();
  let lastDayOfWeek = getSunday(new Date());
  lastDayOfWeek = moment(lastDayOfWeek).format("MM-DD-yyyy");

  const [searchData, setSearchData] = useState({
    search: "",
    customer: "",
    consultants: "",
    candidate: "",
    start_date: firstDayOfWeek,
    end_date: lastDayOfWeek,
    provisional_status: "",
  });

  function getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
  }

  function getSunday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day === 0 ? -6 : 7);
    return new Date(d.setDate(diff));
  }

  const getTrust = async () => {
    dispatch(
      getBookingTrust((result) => {
        if (result?.status === true) {
          setTrust(result);
        }
      })
    );
  };
  const getInvoiceList = (
    pageNo = 1,
    perPage = 15,
    search = "",
    customer = "",
    consultants = "",
    candidate = "",
    start_date = firstDayOfWeek,
    end_date = lastDayOfWeek,
    provisional_status = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(
      getInvoice({
        pageNo,
        perPage,
        search,
        customer,
        consultants,
        candidate,
        start_date,
        end_date,
        provisional_status,
        type,
        column_name,
      })
    );
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setPdfData(pdfData);
    setTimeout(
      getInvoiceList(
        value,
        perPage,
        searchData.search,
        searchData?.customer,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date === null ? firstDayOfWeek : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null ? lastDayOfWeek : moment(searchData?.end_date).format("DD-MM-yyyy"),
        searchData?.provisional_status
      ),
      2000
    );
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(1);
    getInvoiceList(
      1,
      newPerPage,
      searchData.search,
      searchData?.customer,
      searchData?.consultants,
      searchData?.candidate,
      searchData?.start_date === null ? firstDayOfWeek : moment(searchData?.start_date).format("DD-MM-yyyy"),
      searchData?.end_date === null ? lastDayOfWeek : moment(searchData?.end_date).format("DD-MM-yyyy"),
      searchData?.provisional_status
    )
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    handleMenuClose(true);
    setPage(1);
    if (d1) {
      setTimeout(
        getInvoiceList(
          page,
          perPage,
          d1,
          searchData?.customer,
          searchData?.consultants,
          searchData?.candidate,
          searchData?.start_date === null ? firstDayOfWeek : moment(searchData?.start_date).format("DD-MM-yyyy"),
          searchData?.end_date === null ? lastDayOfWeek : moment(searchData?.end_date).format("DD-MM-yyyy"),
          searchData?.provisional_status
        ),
        100
      );
    } else {
      setTimeout(
        getInvoiceList(
          page,
          perPage,
          "",
          searchData?.customer,
          searchData?.consultants,
          searchData?.candidate,
          searchData?.start_date === null ? firstDayOfWeek : moment(searchData?.start_date).format("DD-MM-yyyy"),
          searchData?.end_date === null ? lastDayOfWeek : moment(searchData?.end_date).format("DD-MM-yyyy"),
          searchData?.provisional_status
        ),
        100
      );
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setPage(1);
    handleMenuClose(true);
    setTimeout(
      getInvoiceList(
        page,
        perPage,
        searchData.search,
        searchData?.customer,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date === null ? firstDayOfWeek : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null ? lastDayOfWeek : moment(searchData?.end_date).format("DD-MM-yyyy"),
        searchData?.provisional_status
      ),
      1000
    );
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const downloadCreditNotes = async (
    booking_id,
    invoice_number,
    invoice_name
  ) => {
    setLoadings(true);
    let fileName = invoice_number
      ? "CREDIT NOTES" + invoice_number + ".pdf"
      : "CREDIT NOTES" + invoice_name + ".pdf";
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/generate-credit-notes/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const downloadPdf = async (booking_id, invoice_number) => {
    setLoadings(true);
    const getToken = localStorage.getItem("token") ? localStorage.getItem("token").replace(/['"]+/g, "") : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/generate-invoice/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", invoice_number + ".pdf");
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const [pdfData, setPdfData] = useState({
    id: [],
  });

  const multipleInvoiceDownload = async () => {
    setLoadings(true);
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .post(`${apiConfigs.API_URL}api/organization/multiple-invoice`, pdfData, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Invoice.pdf");
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleCheckboxClick = (event, ids) => {
    const multiplePdf = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked) {
      multiplePdf.id.push(parseFloat(ids));
      setPdfData(multiplePdf);
    } else {
      const newData = multiplePdf.id.filter((item) => item !== parseFloat(ids));
      multiplePdf.id = newData;
      setPdfData(multiplePdf);
    }
  };

  const handleCheckboxAllClick = (event) => {
    const multiplePdf = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked && getInvoiceItem?.data?.data.length > 0) {
      const createArray = [];
      getInvoiceItem?.data?.data.map((row, index) => {
        createArray.push(row.id);
      });
      multiplePdf.id = createArray;
      setPdfData(multiplePdf);
    } else {
      multiplePdf.id = [];
      setPdfData(multiplePdf);
    }
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleReset = () => {
    let data = {
      search: "",
      candidate: "",
      customer: "",
      consultants: "",
      start_date: firstDayOfWeek,
      end_date: lastDayOfWeek,
      provisional_status: "",
    };
    setSearchData(data);
    handleMenuClose(true);
    setPage(1);
    setTimeout(
      getInvoiceList(
        page,
        perPage,
        "",
        searchData?.customer,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date,
        searchData?.end_date,
        searchData?.provisional_status
      ),
      100
    );
  };

  useEffect(() => {
    if (
      (loginUserInfo?.role === "STAFF" &&
        (loginUserInfo?.staffdetails === "Finance" ||
          (loginUserInfo?.staffdetails === "Admin" &&
            loginUserInfo?.is_smt === "Yes"))) ||
      loginUserInfo?.role === "ORGANIZATION"
    ) {
      getTrust();
    }
  }, []);

  useEffect(() => {
    if (
      (loginUserInfo?.role === "STAFF" &&
        (loginUserInfo?.staffdetails === "Finance" ||
          (loginUserInfo?.staffdetails === "Admin" &&
            loginUserInfo?.is_smt === "Yes"))) ||
      loginUserInfo?.role === "ORGANIZATION"
    ) {
      getInvoiceList(
        page,
        perPage,
        searchData.search,
        searchData?.customer,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date === null ? firstDayOfWeek : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null ? lastDayOfWeek : moment(searchData?.end_date).format("DD-MM-yyyy"),
        searchData?.provisional_status,
        order,
        orderBy
      );
    }
  }, [orderBy, order]);
  const navigate = (url) => {
    history.push(url); // or history.replace('/dashboard');
  };


  const onhandlClick = (id) => {
    history.push(`/admin/bookings/${id}/detail`);
  }

  const theme = useTheme();
  const { mode } = useContext(ThemeContext);
  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);

  }, [mode]);
  return (
    <>
      {loading && <Loading open={loading} />}
      {loadings && <Loading open={loadings} />}

      {timesheetMsgError && timesheetMsgError?.message && (
        <Notification
          data={timesheetMsgError?.message}
          status={timesheetMsgError?.status === true ? "success" : "error"}
        />
      )}

      {(loginUserInfo?.role === "STAFF" &&
        (loginUserInfo?.is_smt === "Yes")) ||
        loginUserInfo?.role === "ORGANIZATION" ? (
        <>
          <Paper className={`${classes.root} mb-6`}>
            <Box mb={3} display="flex" alignItems="center" justifyContent="space-between">
              <Box sx={{ display: "flex", alignItems: "center", width: "24%" }}>

                <TextField
                  size="small"
                  placeholder="Search now..."
                  name="search"
                  variant="outlined"
                  onChange={handleSearchChange}
                  onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          style={{
                            color: "#856f6f", // Icon color
                            cursor: "pointer",
                          }}
                          onClick={handleClickSearch}
                        />
                      </InputAdornment>
                    ),
                  }}
                  className="modernSearchField"
                />
              </Box>

              <Box sx={{ display: "flex", alignItems: "end" }}>
                <Tooltip title="Filters">
                  <Button onClick={handleMenu}>
                    <FilterListIcon />
                  </Button>
                </Tooltip>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  open={openMenu}
                  onClose={handleMenuClose}
                  className="filterBookingSearch"
                >
                  <div className={`${classes.filterBox} customPopup`}>
                    {/* <Box className={classes.radioGroup}> */}
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box >
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={customEnLocale}
                            localeText={{
                              start: "Check-in",
                              end: "Check-out",
                            }}
                          >
                            <DatePicker
                              label="Start Date"
                              inputFormat="dd/MM/yyyy"
                              onChange={(newValue) =>
                                setSearchData({
                                  ...searchData,
                                  start_date: newValue,
                                })
                              }
                              firstDayOfWeek={1}
                              value={
                                searchData?.start_date
                                  ? searchData?.start_date
                                  : firstDayOfWeek
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl
                          variant="outlined"
                          fullWidth
                        >
                          <InputLabel>Customer</InputLabel>
                          <Select
                            label="Customer"
                            name="customer"
                            onChange={(e) =>
                              setSearchData({
                                ...searchData,
                                [e.target.name]: e.target.value,
                              })
                            }
                            style={{ width: "100%" }}
                            value={searchData?.customer}
                          >
                            <MenuItem value="">Select Customer</MenuItem>
                            {trust?.data != undefined &&
                              trust?.data &&
                              trust?.data.map((trustList, index) => {
                                return (
                                  <MenuItem
                                    value={trustList.id}
                                    key={index + 11111}
                                  >
                                    {trustList.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box >
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={customEnLocale}
                            localeText={{
                              start: "Check-in",
                              end: "Check-out",
                            }}
                          >
                            <DatePicker
                              label="End Date"
                              inputFormat="dd/MM/yyyy"
                              onChange={(newValue) =>
                                setSearchData({
                                  ...searchData,
                                  end_date: newValue,
                                })
                              }
                              firstDayOfWeek={1}
                              value={
                                searchData?.end_date
                                  ? searchData?.end_date
                                  : lastDayOfWeek
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl
                          fullWidth
                          // className={classes.formControl}
                          variant="outlined"
                        >
                          <InputLabel>Provisional Status</InputLabel>
                          <Select
                            label="provisional_status"
                            name="provisional_status"
                            onChange={(e) =>
                              setSearchData({
                                ...searchData,
                                [e.target.name]: e.target.value,
                              })
                            }
                            value={searchData?.provisional_status}
                          >
                            <MenuItem value="">Select Status</MenuItem>
                            <MenuItem value="CONFIRMED" key={1111}>
                              CONFIRMED
                            </MenuItem>
                            <MenuItem value="CREDIT NOTES" key={11111}>
                              CREDIT NOTES
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    {/* </Box> */}
                    <Box mt={2} mb={1} display="flex" alignItems="center">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        flexGrow={1}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "flex-end" }}
                          className={classes.formControl}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            style={{
                              marginRight: "16px",
                              marginLeft: "16px",
                            }}
                            className={classes.searchIcondet}
                            onClick={handleClickSearch}
                          >
                            Search
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleReset}
                          >
                            Reset
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                    {/* </Box> */}
                  </div>
                </Menu>
                {pdfData.id.length > 0 && (
                  <div className="ml-5">
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={multipleInvoiceDownload}
                      className={classes.downloadButton}
                    >
                      <span className="material-icons mr-2">download</span>{" "}
                      Download PDF
                    </Button>
                  </div>
                )}

                <div className="ml-5">
                  <Button
                    component={Link}
                    to="/admin/invoice-studio"
                    variant="contained"
                    color="primary"
                  >
                    Invoice Studio
                  </Button>
                </div>
              </Box>
            </Box >

            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                  handleCheckboxAllClick={handleCheckboxAllClick}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={(event, property) => {
                    handleRequestSort(
                      property,
                      setOrder,
                      setOrderBy,
                      orderBy,
                      order
                    );
                  }}
                  rowCount={getInvoiceItem?.data?.data?.length}
                  headCells={headCells[0]}
                  pdfDataCount={pdfData.id.length}
                />
                <TableBody>
                  {getInvoiceItem?.data?.data &&
                    getInvoiceItem?.data?.data.map((list, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell scope="row">
                            <Checkbox
                              value={list.id}
                              checked={pdfData.id.includes(list.id)}
                              onClick={(event) =>
                                handleCheckboxClick(event, list.id)
                              }
                              style={{ color: theme.palette.listItem }}
                              className="selectCheckbox"
                            />
                          </TableCell>
                          <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                            {getInvoiceItem?.data?.from + index}
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>
                            <MuiLink
                              component={RouterLink}
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                onhandlClick(list.id)
                              }}
                              underline="hover"
                              sx={{
                                cursor: "pointer",
                                color: "#3e81c3"
                              }}
                            >
                              {list.invoice_number}
                            </MuiLink>
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.type}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>
                            {list.invoice_date}
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.total_hours}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>
                            {list.customer_name}
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>
                            {list.reference_id}
                          </TableCell>

                          <TableCell style={{ width: 220, textAlign: "center", color: theme.palette.listItem }}>
                            {list?.invoice && (
                              <Box
                                component="span"
                                sx={{
                                  display: "inline-block",
                                  marginRight: "8px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  list.type === "Invoice"
                                    ? downloadPdf(list.id, list.invoice_number)
                                    : downloadCreditNotes(list.id, list.invoice_number, list.invoice)
                                }
                              >
                                <GetAppIcon />
                              </Box>
                            )}

                            {/* {list?.invoice && (
                              <Box
                                component="span"
                                sx={{
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                                onClick={() => navigate(`/admin/bookings/${list.id}/detail`)}
                              >
                                <Visibility />
                              </Box>
                            )} */}
                          </TableCell>

                          {/* <TableCell align="right" style={{ width: 100 }}>
                            {list?.invoice && (
                              <Button
                                variant="outlined"
                                size="small"
                                component={Link}
                                to={`/bookings/${list.id}/detail`}
                              >
                                View
                              </Button>
                              // <Link
                              //   variant="contained"
                              //   color="secondary"
                              //   to={`bookings/${list.id}/detail`}
                              //   className="btn btn-secondary"
                              // >
                              //   View
                              // </Link>
                            )}
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                  {getInvoiceItem?.data?.data?.length === 0 && (
                    <TableRow>
                      <TableCell scope="row" colSpan="12" align="center">
                        <div className="" align="center">
                          Sorry,invoice not available!
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePaginationControls
              page={page}
              rowsPerPage={perPage}
              totalRecords={getInvoiceItem?.data?.total}
              onPageChange={handleChangePage}
              handlePerPageChange={handlePerPageChange}
            />
          </Paper >
        </>
      ) : (
        <div className="" align="center">
          <b>Sorry,You have no access!</b>
        </div>
      )
      }
    </>
  );
};

export default Invoice;
